import React from 'react';
import useSetScrollRef from 'hooks/useSetScrollRef';
import HeroWrapper from 'shared/hero-wrapper';

import s from './hero.module.scss';

export default function ContactHero() {
  const hero = useSetScrollRef();
  return (
    <HeroWrapper img="cxn-hero-contact" className={s.hero} ref={hero}>
      <img
        src="/svg/cxn-lets-work.svg"
        alt="cxn-lets-work"
        className={s.img}
      />
    </HeroWrapper>
  );
}
